import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface SelectSituacaoI {
	value: string;
	disabled?: boolean;
	onChange: (event: SelectChangeEvent<string>) => void;
}

export default function SelectSituacao({onChange, value, disabled}: SelectSituacaoI) {

	return (
		<Select
			value={value}
			fullWidth
			onChange={onChange}
			disabled={disabled}
		>
			<MenuItem value="">Selecione</MenuItem>
			<MenuItem value="NE">Não existente (NE)</MenuItem>
			<MenuItem value="NI">Não Inspecionado (NI)</MenuItem>
			<MenuItem value="PV">1ª Ocorrência (PV)</MenuItem>
			<MenuItem value="RE">Recorrente (RE)</MenuItem>
			<MenuItem value="PC">Constante (PC)</MenuItem>
			<MenuItem value="TR">Tratada (TR)</MenuItem>
			<MenuItem value="AU">Aumentou (AU)</MenuItem>
			<MenuItem value="DI">Diminuiu (DI)</MenuItem>
		</Select>
	);
}